import { useEffect, useState } from "react";
import { loadToolUI, type WebToolUI } from "../registry/toolRegistry";

// Lazy-Loader für die ToolUI (D16/D11): lädt das per-Tool `ui.tsx`-Modul on-demand und
// hält es im State. Solange es lädt → `loading`; kein Loader registriert → `undefined`
// (der Result-Viewer fällt dann auf den kind-Fallback-Renderer zurück, D32/D43).
export function useToolUI(toolId: string | undefined): { ui: WebToolUI | undefined; loading: boolean } {
  const [ui, setUi] = useState<WebToolUI | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(Boolean(toolId));

  useEffect(() => {
    if (!toolId) {
      setUi(undefined);
      setLoading(false);
      return;
    }
    let active = true;
    setUi(undefined); // beim Wechsel sofort die alte UI verwerfen (kein Stale-Render)
    setLoading(true);
    void loadToolUI(toolId)
      .then((loaded) => {
        if (active) setUi(loaded);
      })
      .catch(() => {
        // Chunk-Load-Fehler → kein Dauer-Loading; Result-Viewer fällt auf kind-Fallback (D32/D43).
        if (active) setUi(undefined);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [toolId]);

  return { ui, loading };
}
